import styled from "styled-components";
import React from "react";

export const ErrorMessageWrapper = styled.div<{$enabled: boolean}>`
  position: absolute;
  display: grid;
  grid-template-columns: 55px 200px 55px;
  width: ${({$enabled}) => $enabled ? "310px" : "0"};
  height: 50px;
  background-color: rgba(183, 163, 163, 1);
  bottom: 5px;
  right: 5px;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  color: #600000;
  transition: width 0.5s;
  z-index: 1000;

  & div {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
  }
`;


